<template>
  <el-dialog title="服务登记" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
    <el-form :model="addTelHousekeepingInfo" :rules="rules" ref="form" label-width="120px">
      <el-form-item label="服务类型" prop="houseTypeId">
        <el-select v-model="addTelHousekeepingInfo.houseTypeId" placeholder="必填，请选择服务类型" @change="changeHouseType"
          style="width:100%">
          <el-option v-for="(item, index) in addTelHousekeepingInfo.repairSettings" :key="index" :label="item.hktName"
            :value="item.hktId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务" prop="servId">
        <el-select v-model="addTelHousekeepingInfo.servId" placeholder="必填，请选择服务" @change="changeSer"
          style="width:100%">
          <el-option v-for="(item, index) in addTelHousekeepingInfo.housekeepingServs" :key="index"
            :label="item.servName" :value="item.servId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="报修人" prop="applyName">
        <el-input v-model="addTelHousekeepingInfo.applyName" placeholder="必填，请填写报修人">
        </el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="applyTel">
        <el-input v-model="addTelHousekeepingInfo.applyTel" placeholder="必填，请填写联系方式" type="number">
        </el-input>
      </el-form-item>
      <el-form-item label="预约时间" prop="appointmentTime">
        <el-date-picker v-model="addTelHousekeepingInfo.appointmentTime" type="datetime" placeholder="必填，请填写预约时间"
          value-format="yyyy-MM-dd HH:mm:ss" style="width:100%">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="报修内容" prop="context">
        <el-input type="textarea" :rows="3" placeholder="必填，请填写报修内容" v-model="addTelHousekeepingInfo.context">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="saveOwnerRepairInfo">提 交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryHousekeepingType } from '@/api/housekeeping/housekeepingTypeApi'
import { queryHousekeepingServ } from '@/api/housekeeping/housekeepingServApi'
import { saveTelHousekeepingServ } from '@/api/housekeeping/housekeepingServPoolApi'

export default {
  data() {
    return {
      dialogVisible: false,
      addTelHousekeepingInfo: {
        poolId: '',
        houseTypeId: '',
        servId: '',
        servName: '',
        shopId: '',
        applyName: '',
        applyTel: '',
        appointmentTime: '',
        context: '',
        housekeepingServs: [],
        repairSettings: []
      },
      rules: {
        servId: [
          { required: true, message: '报修类型不能为空', trigger: 'blur' }
        ],
        applyName: [
          { required: true, message: '报修人不能为空', trigger: 'blur' },
          { min: 2, max: 50, message: '报修人名称必须在2至50字符之间', trigger: 'blur' }
        ],
        applyTel: [
          { required: true, message: '联系方式不能为空', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '联系方式格式不正确', trigger: 'blur' }
        ],
        appointmentTime: [
          { required: true, message: '预约时间不能为空', trigger: 'blur' }
        ],
        context: [
          { required: true, message: '报修内容不能为空', trigger: 'blur' },
          { max: 2000, message: '报修内容不能超过2000字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(conditions) {
      this.dialogVisible = true
      this.addTelHousekeepingInfo.shopId = conditions.shopId
      this._initAddOwnerRepairInfo()
      this._listRepairSettings(1, 50)
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.clearAddOwnerRepairInfo()
    },
    async saveOwnerRepairInfo() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await saveTelHousekeepingServ(this.addTelHousekeepingInfo)
            this.$message.success('登记成功')
            this.handleClose()
            this.$emit('refresh')
          } catch (error) {
            console.error('保存失败:', error)
          }
        }
      })
    },
    clearAddOwnerRepairInfo() {
      const _repairSettings = this.addTelHousekeepingInfo.repairSettings
      this.addTelHousekeepingInfo = {
        poolId: '',
        servId: '',
        houseTypeId: '',
        shopId: this.addTelHousekeepingInfo.shopId,
        servName: '',
        applyName: '',
        applyTel: '',
        appointmentTime: '',
        context: '',
        housekeepingServs: [],
        repairSettings: _repairSettings
      }
    },
    _initAddOwnerRepairInfo() {
      this.addTelHousekeepingInfo.appointmentTime = new Date()
    },
    async _listRepairSettings(page, rows) {
      try {
        const res = await queryHousekeepingType({
          page,
          row: rows,
          shopId: this.addTelHousekeepingInfo.shopId,
          typeCd: '1001'
        })
        this.addTelHousekeepingInfo.repairSettings = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async _listHousekeepingServs(page, rows, hktId) {
      try {
        const res = await queryHousekeepingServ({
          page,
          row: rows,
          hktId,
          shopId: this.addTelHousekeepingInfo.shopId
        })
        this.addTelHousekeepingInfo.housekeepingServs = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    changeHouseType(hktId) {
      this._listHousekeepingServs(1, 50, hktId)
    },
    changeSer(servId) {
      const item = this.addTelHousekeepingInfo.housekeepingServs.find(i => i.servId === servId)
      if (item) {
        this.addTelHousekeepingInfo.servName = item.servName
      }
    }
  }
}
</script>